import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

// FIXME: Why can't we use app/frontend/controllers/sortable_controller.js ?
export default class extends Controller {
  connect() {
    this.sortable = new Sortable(this.element, {
      animation: 150,
      handle: ".drag-handle",
      onEnd: this.handleDrop.bind(this)
    });
  }

  handleDrop(event) {
    let partnerId = event.item.getAttribute("data-partner-id");
    let position = event.newIndex + 1;

    fetch(`/admin/marketplace/partners/${partnerId}/update_position`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ position: position })
    })
  }
}

